const styles = theme => ({
    dropDown: {
        padding: 0,
        backgroundColor: theme.palette.background.paper
    }
});

export default styles;